(function () {
  var hdr = document.querySelector('.site-header');
  if (hdr) {
    addEventListener('scroll', function () {
      hdr.classList.toggle('scrolled', scrollY > 8);
    }, { passive: true });
  }

  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.rail').forEach(function (rail) {
      var guard = 0;
      do {
        Array.prototype.slice.call(rail.children).forEach(function (c) {
          var d = c.cloneNode(true);
          d.classList.add('dup');
          d.setAttribute('aria-hidden', 'true');
          rail.appendChild(d);
        });
        guard++;
      } while (rail.scrollWidth < innerWidth * 2 && guard < 4);
    });
  }

  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var atc = form.querySelector('[data-atc]');
  var stickyBar = document.querySelector('[data-stickybar]');
  var stickyName = document.querySelector('[data-sticky-name]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var productTitle = (form.dataset.productTitle || '').toUpperCase();
  var buyLabel = form.dataset.buyLabel || 'Get a grip';

  function currentVariant() {
    var checked = form.querySelector('input[name="id"]:checked');
    return checked || null;
  }

  function render() {
    var v = currentVariant();
    if (!v) return;
    var price = v.dataset.price;
    var name = (v.dataset.name || '').toUpperCase();
   
    
    if (stickyPrice) stickyPrice.textContent = price;
  }

  form.addEventListener('change', function (e) {
    if (e.target.name === 'id') render();
  });

  document.querySelectorAll('[data-select-variant]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = form.querySelector('input[name="id"][data-key="' + b.dataset.selectVariant + '"]');
      if (input) {
        input.checked = true;
        render();
      }
      var top = document.getElementById('shop-top');
      if (top) top.scrollIntoView({ behavior: 'smooth' });
    });
  });

  function addToCart(e) {
    e.preventDefault();
    var v = currentVariant();
    if (!v) return;
    var busyTargets = [atc, stickyAtc].filter(Boolean);
    busyTargets.forEach(function (b) { b.setAttribute('disabled', ''); });
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(v.value), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    }).catch(function () {
      busyTargets.forEach(function (b) { b.removeAttribute('disabled'); });
      form.submit();
    });
  }

  form.addEventListener('submit', addToCart);
  if (stickyAtc) stickyAtc.addEventListener('click', addToCart);

  if (stickyBar && atc) {
    var syncBar = function () {
      var off = atc.getBoundingClientRect().bottom < 0;
      stickyBar.classList.toggle('on', off);
      stickyBar.setAttribute('aria-hidden', String(!off));
    };
    addEventListener('scroll', syncBar, { passive: true });
    syncBar();
  }
})();
